import { render, staticRenderFns } from "./freeShipping.vue?vue&type=template&id=5f84c79e&scoped=true&"
import script from "./freeShipping.vue?vue&type=script&lang=ts&"
export * from "./freeShipping.vue?vue&type=script&lang=ts&"
import style0 from "./freeShipping.vue?vue&type=style&index=0&id=5f84c79e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f84c79e",
  null
  
)

export default component.exports